import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from '../contexts/LanguageContext';
import { resetPasswordRequest } from '../hooks/useApi';
import ThemeToggle from '../components/Shared/ThemeToggle';

// Neues Passwort per Einmal-Token (aus dem E-Mail-Link ?token=...) setzen.
export default function ResetPasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!token) {
      setError(t('reset.no_token', 'Ungueltiger oder fehlender Link.'));
      return;
    }
    if (pw.length < 8) {
      setError(t('reset.too_short', 'Passwort: mindestens 8 Zeichen'));
      return;
    }
    if (pw !== pw2) {
      setError(t('reset.mismatch', 'Die Passwoerter stimmen nicht ueberein.'));
      return;
    }
    setSubmitting(true);
    try {
      await resetPasswordRequest(token, pw);
      setDone(true);
      setTimeout(() => navigate('/login', { replace: true }), 2500);
    } catch (err) {
      setError(err?.response?.data?.detail || err?.message
        || t('reset.failed', 'Link ungueltig oder abgelaufen.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="screen-login">
      <div className="login-card">
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}><ThemeToggle /></div>
        <h2 style={{ marginTop: 0 }}>{t('reset.title', 'Neues Passwort setzen')}</h2>
        {done ? (
          <div>
            <p style={{ fontSize: 14, color: 'var(--text-muted)' }}>
              {t('reset.done', 'Passwort gesetzt. Du wirst zum Login weitergeleitet.')}
            </p>
            <Link to="/login">{t('forgot.back_to_login', 'Zurueck zum Login')}</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="field-label">{t('reset.new_pw', 'Neues Passwort')}</label>
              <input className="field-input" type="password" value={pw} autoFocus minLength={8}
                autoComplete="new-password" onChange={(e) => setPw(e.target.value)} required />
            </div>
            <div className="form-group">
              <label className="field-label">{t('reset.new_pw2', 'Passwort wiederholen')}</label>
              <input className="field-input" type="password" value={pw2} minLength={8}
                autoComplete="new-password" onChange={(e) => setPw2(e.target.value)} required />
            </div>
            {error && (
              <div style={{
                background: 'rgba(239,68,68,.1)', border: '1px solid rgba(239,68,68,.3)',
                borderRadius: 8, padding: '8px 12px', fontSize: 12, color: 'var(--danger)',
                marginBottom: 12,
              }}>{error}</div>
            )}
            <button type="submit" className="btn btn-primary" disabled={submitting} style={{ width: '100%' }}>
              {submitting ? t('common.loading', 'Lade...') : t('reset.submit', 'Passwort setzen')}
            </button>
            <div style={{ marginTop: 12, textAlign: 'center' }}>
              <Link to="/login">{t('forgot.back_to_login', 'Zurueck zum Login')}</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
